import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { JobFormData } from "../types/jobTypes";
import { useTranslation } from "react-i18next";

interface QualificationsTabProps {
  jobData: JobFormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, field: keyof JobFormData) => void;
  handleSkillsKeyDown: (e: React.KeyboardEvent<HTMLInputElement>, field: keyof JobFormData) => void;
}

export const QualificationsTab = ({
  jobData,
  handleInputChange,
  handleSkillsKeyDown
}: QualificationsTabProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="hardSkills" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.hardSkills")}
        </Label>
        <Input
          id="hardSkills"
          type="text"
          value={jobData.hardSkills}
          onChange={(e) => handleInputChange(e, "hardSkills")}
          onKeyDown={(e) => handleSkillsKeyDown(e, "hardSkills")}
          placeholder={t("jobs.formWizard.hardSkillsPlaceholder")}
        />
      </div>
      
      <div>
        <Label htmlFor="softSkills" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.softSkills")}
        </Label>
        <Input
          id="softSkills"
          type="text"
          value={jobData.softSkills}
          onChange={(e) => handleInputChange(e, "softSkills")}
          onKeyDown={(e) => handleSkillsKeyDown(e, "softSkills")}
          placeholder={t("jobs.formWizard.softSkillsPlaceholder")}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="educationLevel" className="text-sm font-medium text-gray-700 mb-1 block">
            {t("jobs.formWizard.educationLevel")}
          </Label>
          <Select
            value={jobData.educationLevel}
            onValueChange={(value) => {
              handleInputChange(
                { target: { value } } as React.ChangeEvent<HTMLSelectElement>,
                "educationLevel"
              )
            }}
          >
            <SelectTrigger id="educationLevel">
              <SelectValue placeholder={t("jobs.formWizard.selectEducationLevel")} />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem value="HIGH_SCHOOL">{t("jobs.formWizard.educationLevels.highSchool")}</SelectItem>
                <SelectItem value="ASSOCIATE">{t("jobs.formWizard.educationLevels.associate")}</SelectItem>
                <SelectItem value="BACHELOR">{t("jobs.formWizard.educationLevels.bachelor")}</SelectItem>
                <SelectItem value="MASTER">{t("jobs.formWizard.educationLevels.master")}</SelectItem>
                <SelectItem value="DOCTORATE">{t("jobs.formWizard.educationLevels.doctorate")}</SelectItem>
                <SelectItem value="NOT_REQUIRED">{t("jobs.formWizard.educationLevels.notRequired")}</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      
        <div>
          <Label htmlFor="yearsOfExperience" className="text-sm font-medium text-gray-700 mb-1 block">
            {t("jobs.formWizard.yearsOfExperience")}
          </Label>
          <Input
            id="yearsOfExperience"
            type="text"
            value={jobData.yearsOfExperience}
            onChange={(e) => handleInputChange(e, "yearsOfExperience")}
            placeholder={t("jobs.formWizard.yearsOfExperiencePlaceholder")}
          />
        </div>
      </div>
      
      <div>
        <Label htmlFor="cultureTags" className="text-sm font-medium text-gray-700 mb-1 block">
          {t("jobs.formWizard.cultureTags")}
        </Label>
        <Input
          id="cultureTags"
          type="text"
          value={jobData.cultureTags}
          onChange={(e) => handleInputChange(e, "cultureTags")}
          onKeyDown={(e) => handleSkillsKeyDown(e, "cultureTags")}
          placeholder={t("jobs.formWizard.cultureTagsPlaceholder")}
        />
      </div>
    </div>
  );
};
